import { FormattedCustomerDocument } from 'common/MessagesServicesTypes';

export enum FilterOptions {
	LastMonth = 'Den sidste måned',
	LastYear = 'Det sidste år',
	NewestFirst = 'Nyeste først',
	OldestFirst = 'Ældste først',
	ClearSorting = 'Ryd sortering',
}

export const sortedDocs = (selectedOption: string, filteredDocs: FormattedCustomerDocument[]) => {
	switch (selectedOption) {
		case FilterOptions.OldestFirst: {
			return [...filteredDocs].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
		}
		case FilterOptions.NewestFirst: {
			return [...filteredDocs].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
		}
		case FilterOptions.LastYear: {
			const currentYear = new Date().getFullYear();
			const lastYearDocs = filteredDocs.filter((doc) => {
				const docDate = new Date(doc.date);
				return docDate.getFullYear() === currentYear - 1; // Filter documents for last year (2024)
			});
			return lastYearDocs;
		}
		case FilterOptions.LastMonth: {
			const currentMonth = new Date().getMonth(); // Get current month (0-11)
			const currentYearForMonth = new Date().getFullYear(); // Get current year
			let lastMonth = currentMonth - 1;
			let lastMonthYear = currentYearForMonth;
			if (lastMonth < 0) {
				lastMonth = 11; // December (11)
				lastMonthYear = currentYearForMonth - 1; // Previous year
			}
			const lastMonthDocs = filteredDocs.filter((doc) => {
				const docDate = new Date(doc.date);
				return docDate.getMonth() === lastMonth && docDate.getFullYear() === lastMonthYear; // Filter documents for last month
			});
			return lastMonthDocs;
		}

		case FilterOptions.ClearSorting: {
			return filteredDocs;
		}

		default: {
			return filteredDocs;
		}
	}
};
